import { z } from "zod";

export const errorCodeSchema = z.enum([
  "UNSUPPORTED_FILE",
  "FILE_TOO_LARGE",
  "FILE_NOT_FOUND",
  "INVALID_UPLOAD",
  "PASSWORD_PROTECTED",
  "PAGE_LIMIT_EXCEEDED",
  "ENGINE_TIMEOUT",
  "ENGINE_RATE_LIMITED",
  "CONVERSION_FAILED",
  "OUTPUT_VALIDATION_FAILED",
  "QUOTA_EXCEEDED",
  "SESSION_EXPIRED",
  "IDEMPOTENCY_CONFLICT",
  "INVALID_STATE",
  "ASSET_NOT_FOUND",
  "JOB_NOT_FOUND",
  "UNAUTHORIZED",
  "INVALID_REQUEST",
  "INTERNAL_ERROR",
]);

export type ErrorCode = z.infer<typeof errorCodeSchema>;

export const ERROR_MESSAGES: Readonly<Record<ErrorCode, string>> = {
  UNSUPPORTED_FILE: "仅支持 PDF 文件",
  FILE_TOO_LARGE: "文件超过允许的大小",
  FILE_NOT_FOUND: "文件不存在或已被清理",
  INVALID_UPLOAD: "上传的文件校验失败",
  PASSWORD_PROTECTED: "暂不支持加密 PDF",
  PAGE_LIMIT_EXCEEDED: "PDF 页数超过限制",
  ENGINE_TIMEOUT: "转换超时，请重试",
  ENGINE_RATE_LIMITED: "转换服务忙，请稍后重试",
  CONVERSION_FAILED: "转换失败，请重试",
  OUTPUT_VALIDATION_FAILED: "转换结果校验失败",
  QUOTA_EXCEEDED: "当前使用额度不足",
  SESSION_EXPIRED: "当前页面会话已失效，请重新操作",
  IDEMPOTENCY_CONFLICT: "请求标识已用于其他转换",
  INVALID_STATE: "当前状态不允许该操作",
  ASSET_NOT_FOUND: "文件不存在或已被清理",
  JOB_NOT_FOUND: "转换任务不存在或已被清理",
  UNAUTHORIZED: "无权访问该资源",
  INVALID_REQUEST: "请求参数无效",
  INTERNAL_ERROR: "服务暂时不可用",
};

export const apiErrorSchema = z.object({
  error: z.object({
    code: errorCodeSchema,
    message: z.string(),
    requestId: z.string().min(1),
  }),
});

export type ApiErrorResponse = z.infer<typeof apiErrorSchema>;
